export default class requestParameter {

    constructor(store) {
        this.store = store;
        //一开始传入的数据 
        this.pubParams = store.getters.getRxjsMsg;
    }

    //处理所有推荐组合参数
    firstTourParameter(journeyNum) {
        //处理并格式化筛选数组
        let filters = this.buildFilter();
        //处理并格式化所有接口参数
        let allParams = this.otherParams(journeyNum, filters)
        return allParams;
    }

    /*
        https://wiki.tuniu.org/pages/viewpage.action?pageId=124574290
    */
    //格式化自由组合参数
    secondParameter(loopNumber, journeyNum, channelCount, flightKey = null) {
        let pubParams = this.pubParams.parameter;
        let baseInfo = pubParams.baseInfo;
        //？？？？？这里的数据没有用到吗
        let flightData = pubParams.groupTickets;

        let flightSegList = pubParams.groupTickets.flightSegList[journeyNum - 1];
        let pollTag = loopNumber == 1 ? 0 : 1;
        let v = parseInt((Math.random() * 1000000).toString());
        let parameter = {
            "productId": baseInfo.productId,
            "channelRelationId": "010000000000",
            "flightType": 1,
            "mixType": 2,
            "ruleFlag": 1,
            // "flightKey": flightKey,
            "flightKey": null,
            "channelCount": channelCount, // 轮询用于判断调用方已经拿到的数据和服务端已有的数据是否一致用的，降低服务器压力，提高查询效率 第一次传0，后面根据上一次调用返回的数值设值
            "pollTag": pollTag, //轮询标记 0查询 1轮询   第一次查询传0，后面都传1
            "clientFlag": "MOB-TRAFFIC",
            "departsDate": flightSegList.departureDate,
            "adultCount": baseInfo.adult,
            "childCount": baseInfo.child,
            "babyCount": baseInfo.freeChild,
            "bookCityCode": baseInfo.bookCityCode,
            "backCityCode": flightSegList.dstCityCode,
            "departCityCode": flightSegList.orgCityCode,
            "beginTime": flightSegList.beginTime,
            "endTime": flightSegList.endTime,
            "systemId": 71,
            "v": v,
            "c": JSON.stringify({
                ct: 100
            })
        }
        return parameter;
    }
    //处理并格式化筛选数组
    buildFilter() {
        //筛选项：数组
        let filters = this.store.getters.getFilter;
        //如果筛选数组长度小于等于0，则返回空数组
        let filter = [];
        if (filters.length <= 0) {
            return filter;
        }
        //如果筛选数组有值，则格式化筛选数组
        filter = this.formatFilter(filters);
        return filter;
    }

    //格式化推荐组合数据
    otherParams(journeyNum, filter) {
        //一开始传入的推荐组合的数据
        let pubParams = this.pubParams.parameter;
        let baseInfo = pubParams.baseInfo;

        //机票信息第一个数据：数组
        let flightData = pubParams.groupTickets.singleTicketList.flightTicketLists[0];
        let originFlight = {
            pkgFlight: [{
                resId: flightData.resId,
                isInternational: 0,
                seqNum: flightData.seqNum,
                price: flightData.priceFlightCabinList[0].price,
                fraPrice: flightData.priceFlightCabinList[0].fraPrice || flightData.priceFlightCabinList[0].price
            }]
        };
        let choseTicket = this.store.getters.getChoseTicket;
        let selectedPkgFlight = [];

        let requestParams = {
            productId: baseInfo.productId,
            isFranchise: baseInfo.isFranchise,
            bookCityCode: baseInfo.bookCityCode,
            departCityCode: baseInfo.departCityCode,
            freeChildNum: baseInfo.freeChild,
            childNum: baseInfo.child,
            departDate: baseInfo.departDate,
            journeyNum: journeyNum,
            backCityCode: baseInfo.backCityCode,
            adultNum: baseInfo.adult,
            filters: filter,
            flight: originFlight,
            noCacheFlag: true,
            journeyId: baseInfo.journeyId,
            _: new Date().getTime()
        }

        if (choseTicket && choseTicket.length > 0) {
            selectedPkgFlight = choseTicket.map(function (item) {
                return {
                    seatType: item.base.seatType,
                    flightNo: item.flightNo,
                    journeyNum: item.numberIndex,
                    resFilterId: item.base.resFilterId ? item.base.resFilterId : '',
                    resFilterType: item.base.resFilterType
                };
            });
            requestParams.selectedPkgFlight = selectedPkgFlight;
        }
        return requestParams;
    }


    //格式化筛选数组
    formatFilter(filters) {

        let filter = [];
        if (filters && filters.length > 0) {
            filters.map((item) => {
                let options = item.options;
                let itemchose = [];

                let itemObj = {
                    fieldType: "",
                    fieldValues: [],
                };
                options.map((item2) => {
                    if (item2.checked) {
                        itemchose.push(item2.optionValue)
                    }
                })
                if (itemchose.length > 0) {
                    itemObj.fieldType = item.fieldType;
                    itemObj.fieldValues = itemchose;
                    filter.push(itemObj);
                }
            })
        }
        let addention = {
            fieldType: 5,
            fieldValues: [1]
        }
        filter.push(addention);
        return filter;
    }

    //获取推荐组合所有机票价格？机舱价格？接口请求参数？
    getSecondAllTicketPrice(choseItem) {
        let pubParams = this.pubParams.parameter;
        let baseInfo = pubParams.baseInfo;
        let flightData = pubParams.flightData;
        // let flightInlandPollingCondition = choseItem.flightInlandPollingCondition;
        let flightKey = choseItem.flightKey;

        // let queryId = flightInlandPollingCondition.queryId;
        let queryId = choseItem.queryId;
        let params = {
            channelRelationId: "010100000020",
            bookCityCode: baseInfo.bookCityCode,
            departCityCode: baseInfo.departCityCode,
            backCityCode: baseInfo.backCityCode,
            journeyId: baseInfo.journeyId,
            adultCount: baseInfo.adult,
            childCount: baseInfo.child,
            babyCount: baseInfo.freeChild,
            productId: baseInfo.productId,
            flightNos: flightKey,
            departsDate: baseInfo.departDate,
            orderDiscount: 0,
            queryId: queryId,
            clientFlag: "MOB-TRAFFIC",
            systemId: 71
        }
        return params;

    }

    getRuleInfoParams(flight,cabin) {
        let pubParams = this.pubParams.parameter;
        let baseInfo = pubParams.baseInfo;
        let params = {
            bookCityCode: baseInfo.bookCityCode,
            departCityCode: baseInfo.departCityCode,
            backCityCode: baseInfo.backCityCode,
            productId: baseInfo.productId,
            flightNos: flight.flightKey,
            departsDate: baseInfo.departDate,
            queryId: flight.queryId,
            cabinCodes:this.splicCabin(cabin.priceFlightCabinList),
            vendorId:cabin.vendorId,
            priceInfoId:cabin.priceFlightCabinList && cabin.priceFlightCabinList.length && cabin.priceFlightCabinList[0].priceInfoId
        }
        return params;
    }
    splicCabin(cabinList) {
        let cabin = '';
        cabinList && cabinList.length && cabinList.forEach((item,i) => {
            if (i === 0) {
                cabin += item.cabinCode;
            } else if (i === 1) {
                cabin += "-" + item.cabinCode;
            }
        })
        return cabin
    }

}